/* eslint-disable no-undef */
/* eslint-disable camelcase */
/* eslint-disable no-debugger*/
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { ApiUrl } from '../constant';


export const authApi = createApi({
  reducerPath: "authAPI",
  baseQuery: fetchBaseQuery({
    baseUrl: ApiUrl
  }),
  endpoints: (builder) => ({
    signupUser: builder.mutation({
      query:({firstName, lastName, email, mobileNo, password, role, countryCode, otp, otpId, companyName
      }) => {
        // console.log(" process.env.REACT_APP_BASE_URL_DEV",  process.env.REACT_APP_BASE_URL_DEV);
        return {
          url: `/auth/register`,
          method: "post",
          body: {
              mobile: mobileNo,
              email : email,
              role : role,
              first_name : firstName,
              last_name : lastName,
              country_code : countryCode,
              name: companyName,
              password : password,
              otp : otp,
              otpid: `${otpId}`
        }
      };
    }
    }),
    loginUser: builder.mutation({
      query : ({email, password}) => {
        // console.log(" process.env.REACT_APP_BASE_URL_DEV",  process.env.REACT_APP_BASE_URL_DEV);
        return {
          url: `/auth/login`,
          method: "post",
          body: {
            email:email,
            password:password
          }
        };
      }
    }),
    verifyUser: builder.mutation({
      query : ({email, mobileNo, companyName}) => {
        // console.log(" process.env.REACT_APP_BASE_URL_DEV",  process.env.REACT_APP_BASE_URL_DEV);
        return {
          url: `/auth/validateUser?company_name=${companyName}&email=${email}&mobile=${mobileNo}`,
          method: "GET"
        };
      }
    }),
    forgotPassword: builder.mutation({
      query : (email) => {
        return {
          url: `/auth/forget-Password`,
          method: 'POST',
          body: { "email": email }
        };
      }
    }),
    resetPassword: builder.mutation({
      query : ({ formData, passwords }) => {
        return {
          url: "/auth/reset-password",
          method: 'POST',
          body:{ 
            email: formData.email,
            token: formData.token,
            password: passwords
          }
        };
      }
    }),
    deleteAccount: builder.mutation({
      query : ({ name, email, mobile }) => {
        return {
          url: "/auth/delete-account-request",
          method: 'POST',
          body:{ 
            name: name,
            email: email,
            mobile: mobile
          }
        };
      }
    }),
    sendOtp: builder.mutation({
      query : (payload) => {
        return {
          url: `/otp`,
          method: "post",
          body: payload
        };
      }
    })
  
  })
});



export const { useSignupUserMutation, useLoginUserMutation, useSendOtpMutation, useForgotPasswordMutation, useVerifyUserMutation, useResetPasswordMutation, useDeleteAccountMutation } = authApi;
